<template>
  <nav
    class="sidebar"
    ref="sidebarEl"
    @scroll="onScroll"
  >
    <h2 class="sidebar-heading">Our Service Packages</h2>
    <ul class="menu-list">
      <li v-for="(item, i) in menuItems" :key="i" class="menu-item">
        <router-link
          :to="item.path"
          class="menu-link"
          :class="{ active: currentPath === item.path }"
          @click="scrollToTop"
        >
          <span class="menu-text">{{ item.title }}</span>
          <v-icon
            class="chevron-icon"
            v-if="currentPath === item.path"
            icon="mdi-chevron-right"
          />
        </router-link>
        <span class="underline"></span>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: 'ServicePackagesSidebar',
  data() {
    return {
      menuItems: [
        { title: 'Custom Web & Mobile UX/UI Design', path: '/service-packages/custom-web-mobile-ux-ui-design' },
        { title: 'Business Website Package', path: '/service-packages/business-website-package' },
        { title: 'Marketing Website Package', path: '/service-packages/marketing-website-package' },
        { title: 'Portfolio Website Package', path: '/service-packages/portfolio-website-package' },
        { title: 'Shopify Store Development Package', path: '/service-packages/shopify-store-development' },
        { title: 'Shopify Migration Package', path: '/service-packages/shopify-migration' },
        { title: 'Custom E–Commerce Website Development', path: '/service-packages/custom-ecommerce-development' },
        { title: 'Stripe & Payment Integration', path: '/service-packages/stripe-and-payment-integration' },
        { title: 'API & 3rd–Party Tool Integrations', path: '/service-packages/api-and-3p-integrations' },
        { title: 'AI Code Review & Hardening', path: '/service-packages/ai-code-review-hardening' },
        { title: 'PWA Conversion (Basic)', path: '/service-packages/pwa-conversion-basic' },
        { title: 'PWA Conversion with Database', path: '/service-packages/pwa-conversion-with-database' },
      ],
      scrollStoreKey: 'servicePackagesSidebarScrollTop',
      _scrollSaveRaf: null,
    };
  },
  computed: {
    currentPath() {
      return this.$route.path;
    },
  },
  mounted() {
    // Restore previous sidebar scroll position if available
    if (typeof window !== 'undefined') {
      const saved = sessionStorage.getItem(this.scrollStoreKey);
      if (saved && this.$refs.sidebarEl) {
        this.$refs.sidebarEl.scrollTop = parseInt(saved, 10) || 0;
      }
    }
  },
  // Vue 3
  beforeUnmount() {
    this.persistScroll();
  },
  // If you're on Vue 2, keep this as well; it will be ignored on Vue 3
  beforeDestroy() {
    this.persistScroll();
  },
  methods: {
    // Scroll only the PAGE to top for new route; sidebar scroll stays as-is
    scrollToTop() {
      if (typeof window !== 'undefined') {
        window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      }
    },
    onScroll() {
      // Throttle writes using rAF to avoid spamming sessionStorage
      if (this._scrollSaveRaf) cancelAnimationFrame(this._scrollSaveRaf);
      this._scrollSaveRaf = requestAnimationFrame(() => {
        this.persistScroll();
      });
    },
    persistScroll() {
      if (typeof window === 'undefined' || !this.$refs.sidebarEl) return;
      try {
        sessionStorage.setItem(
          this.scrollStoreKey,
          String(this.$refs.sidebarEl.scrollTop || 0)
        );
      } catch (_) {
        /* ignore storage issues */
      }
    },
  },
};
</script>

<style scoped>
.sidebar {
  position: sticky;
  top: 120px;
  align-self: start;
  max-height: calc(100vh - 0px);
  overflow-y: auto;
  overflow-x: hidden;

  width: 380px; /* keep fixed width */
  background-color: #ffffff;
  border-radius: 8px;
  padding: 24px;
  height: 550px;
  padding-top: 0;
  font-family: Arial, sans-serif;
  text-align: left;
}

/* Sticky heading inside the scrolling sidebar */
.sidebar-heading {
  position: sticky;
  top: 0;
  z-index: 5;
  background: #ffffff;
  padding: 1rem 0 12px 0;
  margin-bottom: 12px;
  font-size: 1.5rem;
  font-weight: 600;
  color: #111827;
  border-bottom: 1px solid #e5e7eb;
  box-shadow: 0 8px 12px -12px rgba(0, 0, 0, 0.25);
}

/* Optional: scrollbar styling */
.sidebar::-webkit-scrollbar { width: 8px; }
.sidebar::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 6px; }
.sidebar::-webkit-scrollbar-thumb:hover { background: #94a3b8; }

.menu-list { list-style: none; padding: 0; margin: 0; }
.menu-item { position: relative; }
.menu-text { font-size: 1.2rem; padding: 0.5rem; }

.menu-link {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 0;
  font-size: 0.9375rem;
  color: #4b5563;
  text-decoration: none;
  transition: color 0.3s ease;
  position: relative;
}
.menu-link::after {
  content: '';
  position: absolute; bottom: 0; left: 0; width: 100%; height: 2px;
  background: linear-gradient(to right, #d1d5db 50%, transparent 50%);
  background-size: 8px 2px;
}
.menu-link::before {
  content: '';
  position: absolute; bottom: 0; left: 0; width: 0; height: 2px;
  background-color: #00aeff; transition: width 0.5s ease; visibility: hidden;
}
.menu-link:hover::before { visibility: visible; width: 100%; }
.menu-link.active::before { visibility: visible; width: 100%; }
.menu-link.active::after,
.menu-link:hover::after { visibility: hidden; }

.chevron-icon { font-size: 2rem; color: #00aeff; }

/* HIDE the sidebar at ≤ 768px */
@media (max-width: 768px) {
  .sidebar { display: none; }
}
</style>
